import JobTypes from "../Jobs/JobTypes";
import { productoPorUnidad, pliegoPorLongitud } from "../Precioso/formulas";

let FormulaTestForm = [
  {
    type: "Divider",
    label: "Formula de Proceso",
    id: "FormTest_div",
    size: 12,
    align: "left",
    orientation: "horizontal",
  },
  {
    inputName: "Formula",
    label: "Formula",
    type: "Select",
    size: { sm: 12, md: 3 },
    options: [
      {
        text: "Producto por unidad",
        value: "productoPorUnidad",
      },
      {
        text: "Centimetros lineales",
        value: "pliegoPorLongitud",
      },
    ],
    id: "id_401",
    help: "Seleccione el tipo de formula.",
  },
  {
    inputName: "Valor",
    label: "Valor del proceso",
    type: "SmartMeasure",
    subtype: "currency",
    size: { sm: 12, md: 3 },
    step: 0.0001,
    id: "id_401",
    required: true,
  },
  {
    inputName: "Minimo",
    type: "SmartMeasure",
    subtype: "currency",
    size: { sm: 12, md: 3 },
    id: "id_402",
    required: true,
  },
  {
    inputName: "Entrada",
    type: "SmartMeasure",
    subtype: "currency",
    size: { sm: 12, md: 3 },
    id: "id_403",
    required: true,
  },
  {
    type: "Divider",
    label: "Configuracion",
    id: "FormTest_div",
    size: 12,
    align: "left",
    orientation: "horizontal",
  },
  {
    inputName: "Longitud",
    label: "Largo",
    type: "SmartMeasure",
    subtype: "length",
    size: { sm: 12, md: 4 },
    id: "id_404",
    required: false,
  },
  {
    inputName: "firstBreakpoint",
    label: "Breakpoint 1",
    type: "SmartMeasure",
    subtype: "length",
    size: { sm: 12, md: 4 },
    step: 1,
    id: "id_405",
    required: false,
  },
  {
    inputName: "secondBreakpoint",
    label: "Breakpoint 2",
    type: "SmartMeasure",
    subtype: "length",
    size: { sm: 12, md: 4 },
    step: 1,
    id: "id_406",
    required: false,
  },
  {
    type: "Divider",
    label: "Ajustes del Grafico",
    id: "FormTest_div",
    size: 12,
    align: "left",
    orientation: "horizontal",
  },
  {
    inputName: "minRange",
    label: "Cantidad minima",
    size: { sm: 12, md: 4 },
    type: "SmartMeasure",
    step: 1,
    id: "id_407",
    required: true,
  },
  {
    inputName: "maxRange",
    label: "Cantidad maxima",
    size: { sm: 12, md: 4 },
    type: "SmartMeasure",
    step: 1,
    id: "id_408",
    required: true,
  },
  {
    inputName: "stepRange",
    label: "Pasos",
    size: { sm: 12, md: 4 },
    type: "SmartMeasure",
    id: "id_409",
    required: true,
  },
];

export default FormulaTestForm;
